import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import inRange from 'lodash/inRange';
import { BOOKING_STATUS } from '$app/apps/bookings/containers/BookingPage/constants';
import Title from '$app/apps/bookings/components/Title';
import ActionButton from '$app/apps/bookings/components/ActionButton';
import AddDiscountPopup from './AddDiscountPopup';
import { invitationIsReadonly } from '../../utils';

const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  margin-left: auto;
`;

const TitleStyled = styled(Title)`
  margin: 0 15px 0 0;
`;

/**
 * Rules for adding Work operation & coupon code
 * https://docs.google.com/document/d/1GPZ2pHgUJSNd8QMnipke_lqgLdfalmwGhIWksljpBDs/edit
 */
function Header({
  booking,
  onAddWorkOperation,
  onAddCouponCode,
  displayAdjustmentButton,
  onAdjustment,
  onOpenKIS,
  children,
}) {
  const { masterStatusId, quote } = booking;
  const hasAdditionalDiscount = quote?.lineItems?.some(li => li.type === 'additional-discount');

  const HeaderButtons = () => {
    if (invitationIsReadonly()) return null;
    return (
      <>
        {(masterStatusId <= BOOKING_STATUS.AT_GARAGE ||
          masterStatusId === BOOKING_STATUS.GARAGE_DECLINED) && (
          <ActionButton onClick={onAddWorkOperation} icon="plus-circle">
            Work operation
          </ActionButton>
        )}
        {inRange(masterStatusId, BOOKING_STATUS.UNALLOCATED, BOOKING_STATUS.AT_GARAGE + 1) && (
          <ActionButton onClick={onAddCouponCode} icon={hasAdditionalDiscount ? 'edit' : 'plus-circle'}>
            {hasAdditionalDiscount ? 'Edit Discount' : 'Add Discount'}
            {hasAdditionalDiscount && <span style={{ fontWeight: 700, marginLeft: '4px' }}>(1)</span>}
          </ActionButton>
        )}
        {displayAdjustmentButton && (
          <ActionButton onClick={onAdjustment} icon="plus-circle">
            Adjustment
          </ActionButton>
        )}
      </>
    );
  };

  return (
    <div>
      <HeaderDiv>
        <LeftSide>
          <TitleStyled>{children}</TitleStyled>
          <HeaderButtons />
        </LeftSide>
        <RightSide>
          <ActionButton onClick={onOpenKIS} icon="car">
            Open in KIS
          </ActionButton>
        </RightSide>
      </HeaderDiv>
      <AddDiscountPopup />
    </div>
  );
}

export default connect()(Header);
